import Vue from 'vue'
import VueRouter from 'vue-router'
import { isLoggedIn } from 'axios-jwt'
import Login from '@/views/Login'
import Access from '@/views/AccessDenied'

// --- Sidebar menu ---------------------------------------------------
import CRM from '@/router/sidebar-menu/crm'
import Clients from '@/router/sidebar-menu/clients'
import Climbing from '@/router/sidebar-menu/climbing'
import Safari from '@/router/sidebar-menu/safari'
import DayTrips from '@/router/sidebar-menu/day-trips'
import IslandVacation from '@/router/sidebar-menu/island-vacation'
import Reservation from '@/router/sidebar-menu/reservation'
import ReservationDB from '@/router/sidebar-menu/reservation-db'
import ProductStorage from '@/router/sidebar-menu/product-storage'
import EquipmentStorage from '@/router/sidebar-menu/equipment-storage'
import Transfer from '@/router/sidebar-menu/transfer'
import CarManagement from '@/router/sidebar-menu/car-management'
import Employees from '@/router/sidebar-menu/employees'
import HotelManagement from '@/router/sidebar-menu/hotel-management'
import Finance from '@/router/sidebar-menu/finance'
import Administrative from '@/router/sidebar-menu/administrative'
import Common from '@/router/sidebar-menu/common'
import Storage from '@/router/sidebar-menu/storage'

Vue.use(VueRouter)

let routes = [
  {
    path: '/',
    name: 'base',
    meta: {
      roles: []
    },
  },
  {
    path: '/fingerprint',
    name: 'fingerprint',
    component: () => import('@/views/Fingerprint'),
    meta: {
      title: 'Fingerprint',
      roles: ['general_manager']
    }
  },
  Clients,
  Reservation,
  ReservationDB,
  ProductStorage,
  Transfer,
  CarManagement,
  Employees,
  Storage,
  {
    path: '/me',
    name: 'me',
    component: () => import('@/views/Me'),
    meta: {
      title: 'My profile',
      roles: []
    },
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      layout: 'welcome',
      title: 'Login',
      roles: []
    },
  },
  {
    path: '/access-denied',
    name: 'access-denied',
    component: Access,
    meta: {
      title: 'Access denied',
      roles: []
    },
  },
  {
    path: '*',
    redirect: { name: 'base' }
  },
]
const alt_routes = [
  CRM,
  Climbing,
  Safari,
  DayTrips,
  IslandVacation,
  EquipmentStorage,
  HotelManagement,
  Finance,
  Administrative,
  Common,
]

if (process.env.VUE_APP_ALARM !== 'true') routes =  [...alt_routes, ...routes]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

const checkRoles = (userRoles, routeRoles) => {
  if (!userRoles.length || !routeRoles.length) return true
  return userRoles.some(role => routeRoles.includes(role.code))
}

router.beforeEach((to, from, next) => {
  const loggedIn = isLoggedIn()
  const userRoles = JSON.parse(localStorage.getItem('userGroups')) || []

  if (loggedIn) {
    if (to.name === 'login') next({ name: userRoles[0].index_page })
    else if (to.name === 'access-denied' || checkRoles(userRoles, to.meta.roles)) next()
    else next({ name: 'access-denied' })
  } else {
    if (to.name === 'login') next()
    else next({ name: 'login' })
  }

  if (to.meta.title) document.title = `${to.meta.title} | Altezza Board`
})

export default router
